import { defineStore } from 'pinia';
import { ref } from 'vue';
import { SessionStorage } from 'quasar'
import api from '../services/api'
import { useAccountStore } from "stores/account";

export const useAppsumoStore = defineStore('appsumo', () => {
  const licenseKey = ref(null)

  async function assignLicense() {
    const account = await api.assignAppsumoLicense(licenseKey.value)
    if (!account) {
      return false
    }
    const accountStore = useAccountStore()
    await accountStore.loadAccount(true)
    $reset()
    return true
  }

  function $reset() {
    licenseKey.value = null
    SessionStorage.remove('appsumoLicenseKey')
  }

  async function init(license) {
    if (license === 'reset') {
      $reset()
      return
    }
    if (license) {
      licenseKey.value = license
      SessionStorage.set('appsumoLicenseKey', { licenseKey: license })
    }
    const lic = SessionStorage.getItem('appsumoLicenseKey')
    if (lic) {
      licenseKey.value = lic.licenseKey
    }
  }

  return {
    $reset,
    assignLicense,
    init,
    licenseKey,
  }
})
